import {
  Box,
  Button,
  Collapse,
  Heading,
  HStack,
  IconButton,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { useAppDispatch, useAppSelector } from "../../Store/hooks";
import {
  toggleMovingNode,
  setHoverNode,
  clearMovingNodes,
  toggleBlockedItem,
} from "../../Store/ConstructorReducer";
import { mapNames } from "../../Utils";
import { useRef } from "react";
import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";

type ElemMeta = { key: string; name: string; type: string };

let timer: NodeJS.Timeout | null = null;
let startDate = new Date();

const Category = (props: { name: string; items: ElemMeta[] }) => {
  const dispatch = useAppDispatch();

  const movingNodes = useAppSelector((state) => state.main.movingNodes);

  let hasChoosen = false;
  for (const item of props.items) {
    if (movingNodes.indexOf(item.key) !== -1) hasChoosen = true;
  }

  const selectAll = () => {
    dispatch(clearMovingNodes());
    dispatch(toggleMovingNode(props.items.map((item: ElemMeta) => item.key)));
  };

  const stopTimer = (callback1: Function, callback2: Function) => {
    if (timer) {
      const ms = new Date().getTime() - startDate.getTime();
      if (ms / 1000 > 3) callback2();
      else callback1();
      clearInterval(timer);
      timer = null;
    }
  };

  /**
   *
   * @param callback1 Callback для случаев менее 3с
   * @param callback2 Callback для остальных случаев
   */
  const startTimer = (callback1: Function, callback2: Function) => {
    if (!timer) {
      startDate = new Date();
      timer = setInterval(() => {
        const ms = new Date().getTime() - startDate.getTime();
        if (ms / 1000 > 3) {
          stopTimer(callback1, callback2);
        }
      }, 50);
    }
  };

  const blockItem = (key: string) => {
    console.log(`Block ${key}`);
    dispatch(toggleBlockedItem(key));
  };

  const blockedItems = useAppSelector((state) => state.main.blockedItems);

  const deselectAll = () => {
    for(const item of props.items) {
      if(movingNodes.indexOf(item.key) !== -1) dispatch(toggleMovingNode(item.key));
    }
  }

  if (props.items.length === 0) return null;
  return (
    <Box>
      <HStack justify="space-between">
        <Text>{props.name}</Text>
        {hasChoosen ? (
          <Button variant="ghost" _hover={{ bg: "none" }} onClick={deselectAll}>
            Снять выделение
          </Button>
        ) : (
          <Button variant="ghost" _hover={{ bg: "none" }} onClick={selectAll}>
            Выбрать все
          </Button>
        )}
      </HStack>
      {props.items.map((elem: ElemMeta) => (
        <Button
          style={
            blockedItems.indexOf(elem.key) !== -1 ? { background: "red" } : {}
          }
          onMouseOver={() => dispatch(setHoverNode(elem.key))}
          onMouseOut={() => dispatch(setHoverNode(""))}
          key={elem.name}
          onMouseDown={() => {
            startTimer(
              () => {},
              () => blockItem(elem.key)
            );
          }}
          onMouseUp={() => {
            stopTimer(
              () => dispatch(toggleMovingNode(elem.key)),
              () => blockItem(elem.key)
            );
          }}
          m={1}
          opacity={movingNodes.indexOf(elem.key) !== -1 ? 0.5 : 1}
        >
          {elem.name}
        </Button>
      ))}
    </Box>
  );
};

const ElementSwitcher = () => {
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: true });
  const ref = useRef<HTMLDivElement>(null);
  const types = useAppSelector((state) => state.main.types);
  const groupsState = useAppSelector((state) => state.main.groups);
  const counter: { [key: string]: number } = {};
  const numbers: ElemMeta[] = [];
  for (const key in types) {
    const type = types[key];
    if (!counter[type]) counter[type] = 1;
    else counter[type] += 1;
    numbers.push({
      key,
      name: (type === 'group' && groupsState[key]) ? groupsState[key].name : `${mapNames(types[key], false)} ${counter[type]}`,
      type: types[key],
    });
  }

  const monuments: ElemMeta[] = numbers.filter(
    (elem: ElemMeta) => elem.type === "monument"
  );

  const tombstones: ElemMeta[] = numbers.filter(
    (elem: ElemMeta) => elem.type === "tombstone"
  );

  const coverings: ElemMeta[] = numbers.filter(
    (elem: ElemMeta) => elem.type === "covering"
  );

  const fences: ElemMeta[] = numbers.filter(
    (elem: ElemMeta) => elem.type === "fence"
  );

  const accessories: ElemMeta[] = numbers.filter(
    (elem: ElemMeta) => elem.type === "accessory"
  );

  const elements: ElemMeta[] = numbers.filter(
    (elem: ElemMeta) => elem.type === "element"
  );

  const groups: ElemMeta[] = numbers.filter(
    (elem: ElemMeta) => elem.type === "group"
  );

  return (
    <Box pos="relative" w="100%">
      <Heading
        cursor="pointer"
        size="md"
        variant="editor"
        textAlign="center"
        onClick={onToggle}
      >
        Объекты
      </Heading>
      <IconButton
        pos="absolute"
        top={".5rem"}
        right={".5rem"}
        icon={
          isOpen ? (
            <ChevronUpIcon boxSize={"3rem"} />
          ) : (
            <ChevronDownIcon boxSize={"3rem"} />
          )
        }
        aria-label={isOpen ? "Свернуть" : "Раскрыть"}
        onClick={onToggle}
      />
      <Collapse unmountOnExit={false} in={isOpen} animateOpacity>
        <Box ref={ref} p={3}>
          <Category name={"Памятники"} items={monuments} />
          <Category name={"Цветники"} items={tombstones} />
          <Category name={"Покрытия"} items={coverings} />
          <Category name={"Ограды"} items={fences} />
          <Category name={"Аксессуары"} items={accessories} />
          <Category name={"Элементы"} items={elements} />
          <Category name={"Группы"} items={groups} />
        </Box>
      </Collapse>
    </Box>
  );
};

export default ElementSwitcher;
